var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchTutorialArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 162 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 610",
    d: "M2 1V0H0V1H1H2ZM80.2929 52.7071C80.6834 53.0976 81.3166 53.0976 81.7071 52.7071L88.0711 46.3431C88.4616 45.9526 88.4616 45.3195 88.0711 44.9289C87.6805 44.5384 87.0474 44.5384 86.6569 44.9289L81 50.5858L75.3431 44.9289C74.9526 44.5384 74.3195 44.5384 73.9289 44.9289C73.5384 45.3195 73.5384 45.9526 73.9289 46.3431L80.2929 52.7071ZM1 1H0V3.33487H1H2V1H1ZM17.7901 20.125V21.125H62.893V20.125V19.125H17.7901V20.125ZM81 38.232H80V41.125H81H82V38.232H81ZM81 41.125H80V52H81H82V41.125H81ZM62.893 20.125V21.125C72.3409 21.125 80 28.7841 80 38.232H81H82C82 27.6795 73.4455 19.125 62.893 19.125V20.125ZM1 3.33487H0C0 13.1601 7.96491 21.125 17.7901 21.125V20.125V19.125C9.06948 19.125 2 12.0555 2 3.33487H1Z",
    fill: "url(#paint0_linear_0_53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 611",
    d: "M160 1V0H162V1H161H160ZM81.7071 52.7071C81.3166 53.0976 80.6834 53.0976 80.2929 52.7071L73.9289 46.3431C73.5384 45.9526 73.5384 45.3195 73.9289 44.9289C74.3195 44.5384 74.9526 44.5384 75.3431 44.9289L81 50.5858L86.6569 44.9289C87.0474 44.5384 87.6805 44.5384 88.0711 44.9289C88.4616 45.3195 88.4616 45.9526 88.0711 46.3431L81.7071 52.7071ZM161 1H162V3.33487H161H160V1H161ZM144.21 20.125V21.125H99.107V20.125V19.125H144.21V20.125ZM81 38.232H82V41.125H81H80V38.232H81ZM81 41.125H82V52H81H80V41.125H81ZM99.107 20.125V21.125C89.6591 21.125 82 28.7841 82 38.232H81H80C80 27.6795 88.5545 19.125 99.107 19.125V20.125ZM161 3.33487H162C162 13.1601 154.035 21.125 144.21 21.125V20.125V19.125C152.931 19.125 160 12.0555 160 3.33487H161Z",
    fill: "url(#paint1_linear_0_53)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_53",
    x1: 41,
    y1: 1,
    x2: 41,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129808,
    stopColor: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_53",
    x1: 121,
    y1: 1,
    x2: 121,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129808,
    stopColor: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTutorialArrowDown);
export default __webpack_public_path__ + "static/media/search-tutorial-arrow-down.daef390cf665433a0649dc60f2568dc7.svg";
export { ForwardRef as ReactComponent };